import {
  FilterOperators,
  type FilterOperatorObject,
} from '@/components/DataTable';

export const StringOperators: FilterOperatorObject[] = [
  { value: FilterOperators.INCLUDES, label: 'Includes' },
  { value: FilterOperators.EXCLUDES, label: 'Excludes' },
  { value: FilterOperators.CONTAINS, label: 'Contains' },
  { value: FilterOperators.NOT_CONTAINS, label: 'Does not contain' },
];

export const EnumOperators: FilterOperatorObject[] = [
  { value: FilterOperators.INCLUDES, label: 'Includes' },
  { value: FilterOperators.EXCLUDES, label: 'Excludes' },
];

export const NumberOperators: FilterOperatorObject[] = [
  { value: FilterOperators.INCLUDES, label: 'Includes' },
  { value: FilterOperators.EXCLUDES, label: 'Excludes' },
];

export const DateOperators: FilterOperatorObject[] = [
  { value: FilterOperators.GREATER_THAN, label: 'Is After' },
  { value: FilterOperators.LESS_THAN, label: 'Is Before' },
  { value: FilterOperators.BETWEEN, label: 'Is Between' },
];

// Value-less operators (Is Empty / Is Not Empty) and the per-type arrays that
// add them. Shared so every shadow-ai table uses the same labels; the base
// arrays above stay value-less-free for tables that don't want them.
export const EmptyOperators: FilterOperatorObject[] = [
  { value: FilterOperators.IS_EMPTY, label: 'Is Empty' },
  { value: FilterOperators.IS_NOT_EMPTY, label: 'Is Not Empty' },
];

export const StringOperatorsWithEmpty: FilterOperatorObject[] = [
  ...StringOperators,
  ...EmptyOperators,
];
export const EnumOperatorsWithEmpty: FilterOperatorObject[] = [
  ...EnumOperators,
  ...EmptyOperators,
];
export const NumberOperatorsWithEmpty: FilterOperatorObject[] = [
  ...NumberOperators,
  ...EmptyOperators,
];
export const DateOperatorsWithEmpty: FilterOperatorObject[] = [
  ...DateOperators,
  ...EmptyOperators,
];
